<template>
  <Input
    v-if="item.type === 'input'"
    :type="item.inputType"
    v-model="item.value"
    :placeholder="item.placeholder"
    :readonly="item.readonly"
    :disabled="item.disabled"
    :autosize="item.autosize"
    :maxlength="item.maxlength"
    :show-word-limit="item.showWordLimit"
  />
  <Select
    v-else-if="item.type === 'select'"
    v-model="item.value"
    transfer
    :placeholder="item.placeholder"
    :disabled="item.disabled"
    :multiple="item.multiple"
    @on-change="(val) => typeOf(item.onChange) === 'function' && item.onChange(val, item, formItems)"
  >
    <Option v-for="o in (item.options || [])" :key="o.value" :value="o.value">{{o.text}}</Option>
  </Select>
  <DatePicker
    v-else-if="['year', 'month', 'date', 'datetime'].includes(item.type)"
    v-model="item.value"
    :type="item.type"
    :format="item.format || 'yyyy-MM-dd'"
    :placement="item.placement || 'bottom'"
    :placeholder="item.placeholder"
    transfer
  ></DatePicker>
  <div v-else-if="item.type === 'datetimerange'">
    <ButtonGroup v-if="item.quickBtn">
      <Button
        v-for="btn in item.quickBtn"
        :key="btn.day"
        @click="item.value0 = calcBeforeDay(btn.day);item.value1 = new Date();"
        :type="(formatDate(item.value0) === formatDate(calcBeforeDay(btn.day)) && formatDate(item.value1) === formatDate(new Date())) ? 'primary': 'default'"
      >
        {{btn.label}}
      </Button>
    </ButtonGroup>
    &nbsp;
    <DatePicker
      type="date"
      v-model="item.value0"
      :options="optionsStart"
      style="width: 110px"
      transfer
    ></DatePicker>
    -
    <DatePicker
      type="date"
      v-model="item.value1"
      :options="optionsEnd"
      style="width: 110px"
      transfer
    ></DatePicker>
  </div>
  <RadioGroup
    v-else-if="item.type === 'radio'"
    v-model="item.value"
    @on-change="(val) => { typeOf(item.onChange) === 'function' && item.onChange(val) }"
  >
    <Radio v-for="o in (item.radios || [])" :key="o.value" :label="o.value" :disabled="item.disabled">{{o.label}}</Radio>
  </RadioGroup>
  <CheckboxGroup v-else-if="item.type === 'checkbox'" v-model="item.value">
    <Checkbox v-for="o in (item.checks || [])" :key="o.value" :label="o.value">{{o.label}}</Checkbox>
  </CheckboxGroup>
  <i-Switch v-else-if="item.type === 'switch'" v-model="item.value" />
  <ButtonGroup v-else-if="item.type === 'btnGroup'">
    <Button
      v-for="btn in item.btns"
      :key="btn.label"
      @click="item.value = btn.value"
      :type="item.value === btn.value ? 'primary': 'default'"
    >
      {{btn.label}}
    </Button>
  </ButtonGroup>
  <div v-else-if="item.type === 'month'">
    <ButtonGroup v-if="item.quickBtn">
      <Button
        v-for="btn in item.quickBtn"
        :key="`typeMonth-${btn.month}`"
        @click="item.value = calcBeforeDay(btn.month)"
        :type="formatDate(item.value, 'yyyy-MM') === formatDate(btn.month, 'yyyy-MM') ? 'primary': 'default'"
      >
        {{btn.label}}
      </Button>
    </ButtonGroup>
    &nbsp;
    <DatePicker type="month" v-model="item.value"></DatePicker>
  </div>
  <label v-else-if="item.type === 'text'">{{item.value}}</label>
  <Tree
    v-else-if="item.type === 'tree'"
    :data="item.treeData"
    :show-checkbox="item.showCheckbox"
    @on-select-change="(selected, current) => typeOf(item.onSelectChange) === 'function' && item.onSelectChange(selected, current, item)"
    @on-check-change="(selected, current) => typeOf(item.onCheckChange) === 'function' && item.onCheckChange(selected, current, item)"
  ></Tree>
  <div v-else-if="item.type === 'tag'">
    <span v-if="!item.tags || (item.tags.length === 0)">无数据</span>
    <Tag v-else v-for="(t, i) in item.tags" :key="`${t.value}${i}`">{{ t.text }}</Tag>
  </div>
  <div v-else-if="item.type === 'ul'">
    <div class="textBox" v-if="!!item.options.length">
      <p class="text" v-for="item in item.options" :key="item.value">{{ item.text }}</p>
    </div>
    <p v-else class="text errorText">{{ item.tips }}</p>
  </div>
  <div v-else-if="item.type === 'appointmentDate'" class="appointmentDate">
    <div>
      <DatePicker
        type="date"
        :editable="false"
        :clearable="false"
        v-model="item.date.value"
        :options="item.date.options"
        transfer
        style="width: 100%;"
      />
    </div>
    <div>
      <Select v-model="item.select.value" transfer>
        <Option v-for="o in item.select.options" :key="o.value" :value="o.value">{{ o.text }}</Option>
      </Select>
    </div>
  </div>
</template>
<script>
import { calcBeforeDay, calcBeforeMonth, formatDate } from '@libs/util'
export default {
  name: 'my-form-item',
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          type: null, // input, datepicker, select, radio, checkbox, textarea, switch
          inputType: null,
          label: '',
          value: null,
          placeholder: '',
          format: '',
          placement: '',
          rules: null, // [], {}
          options: [], // select
          radios: [], // radio
          checks: [] // checkbox,
        }
      }
    },
    formItems: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      calcBeforeDay,
      calcBeforeMonth,
      formatDate,
      optionsStart: {
        disabledDate: (date) => {
          return date > new Date(this.item.value1) || date > Date.now()
        }
      },
      optionsEnd: {
        disabledDate: (date) => {
          return date < new Date(this.item.value0) || date > Date.now()
        }
      }
    }
  },
  methods: {
    typeOf (val) {
      return typeof(val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.textBox {
  border: 1px solid #dcdee2;
  border-radius: 4px;
  padding: 0px 7px;
  .text {
    color: #515a6e;
  }
}
.errorText {
  color: $error;
}
.appointmentDate {
  display: flex;
  align-items: center;
  &>div {
    flex: 1;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
